<template>

    <!-- film info -->
    <div v-if="films" style="margin: 15px">
      <div class="row">
        <div class="film-list">
            <div v-for="(film) in films" :key="film._id" :class="{'viewed-film': getFilmViewed(film._id), 'no-official-nominations': hasNoOfficialNominationInThisCategory(film)}">

              <div class="row">

                <div class="col-auto" style="padding-right: 0px;">
                  <FilmCheckbox :film_id="film._id"></FilmCheckbox>
                </div>

                <div class="col" style="padding-right: 0px; text-align: left;">
                  <a @click="showFilmDetails(film._id)" >
<!--                    <span class="film-name-text">{{film.name}}</span><sup v-if="film.footnotes" class="nomination-footnote">{{footnoteNumString(film.footnotes)}}</sup><FilmReviewedIndicator :film_id="film._id" :debug_film_name="film.name"></FilmReviewedIndicator>-->
                    <span class="film-name-text">{{film.name}}</span><FilmReviewedIndicator :film_id="film._id" :debug_film_name="film.name"></FilmReviewedIndicator>
                  </a>
                  <LanguageIcon class="language-icon" v-if="!['en','xx'].includes(film.original_language)" :language_code="film.original_language" :superscript="true"></LanguageIcon>
                  <FriendIconGroup :film_id="film._id"></FriendIconGroup>
                  <br>
                </div>
              </div>

              <ul>
                <li v-for="nomination in film.nominationsForCategory(category_name)" :key="nomination._id"
                    :class="{li_win: nomination.won, li_unofficial_nom: nomination.unofficial, li_nom: !(nomination.won || nomination.unofficial)}">
                  <span class="nominee-text">{{nomination.nominee_display_text}}</span><sup v-if="nomination.footnotes" class="nomination-footnote">{{footnoteNumString(nomination.footnotes)}}</sup>
                </li>
              </ul>
            </div>
        </div>
      </div>
    </div>

  <!-- placeholder glow -->
  <div v-else class="placeholder-wave" style="margin: 15px">
    <div class="row">
      <div class="film-list">
        <div v-for="index in 6" :key="index">
          <p class="placeholder col-12"></p>
          <ul>
            <li>
              <small class="placeholder col-12"></small>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import {Film} from "@/film";
import { userStore } from "@/userStore";
import FilmCheckbox from "@/components/FilmCheckbox.vue";
import LanguageIcon from "@/components/LanguageIcon.vue";
import FriendIconGroup from "@/components/friends/icons/FriendIconGroup.vue";
import analytics from "@/analytics";
import FilmReviewedIndicator from "@/components/FilmReviewedIndicator.vue";

export default {
  name: "ModalBodyForCategory",
  components: {FilmReviewedIndicator, FriendIconGroup, LanguageIcon, FilmCheckbox},
  props: ['category_name', 'ceremony', 'link_location'],
  inject: ['showFilmDetails'],
  data() {
    return {
      time_mounted: Date.now(),
      films: null,
      footnotes: [],
      axiosAbortcontroller: null,
      userStore
    }
  },
  async created() {
    this.axiosAbortcontroller = new AbortController();

    return axios.get(`/api/ceremony/${this.ceremony}/films/${encodeURIComponent(this.category_name)}`, { signal: this.axiosAbortcontroller.signal } )
        .then((response) => {

          this.films = response.data.map(f => new Film(f)).sort((film1, film2) => {

            // push films with winners to the top
            if ( film1.nominationsForCategory(this.category_name)[0].won ) {
              return -1;
            }
            if ( film2.nominationsForCategory(this.category_name)[0].won ) {
              return 1;
            }

            // push films with unofficial noms to the bottom
            if ( film1.nominationsForCategory(this.category_name)[0].unofficial ) {
              return 1;
            }
            if ( film2.nominationsForCategory(this.category_name)[0].unofficial ) {
              return -1;
            }
            return 0;
          });

          // gather the film and nomination footnotes, ensuring there are no dups
          this.footnotes = [ ...new Set(
              this.films.reduce((accFootnotes, curFilm) => {
                return [
                    ...accFootnotes,
                    //...curFilm.footnotes,
                    ...curFilm.nominationsForCategory(this.category_name).reduce((accNomFootnotes, curNomination) => {
                        return [
                            ...accNomFootnotes,
                            ...(curNomination.footnotes || [])
                        ];
                    }, [])
                ];
              }, [])
          )];

          // tell my parent this film is done loading
          this.$emit('category-details-loaded', this.films, this.footnotes);

          this.time_mounted = Date.now();
        })
        .catch(err => {
          if ( err.code !== 'ERR_CANCELED') {
            analytics.notifyBugsnagOfError(err);
          }
        })
        .finally(() => {
          this.axiosAbortcontroller = null;
        });
    },

  mounted() {
  },

  unmounted() {
    // if we're mid-download, cancel it
    if ( this.axiosAbortcontroller ) {
      this.axiosAbortcontroller.abort();
      this.axiosAbortcontroller = null;

      // if the download happened, send an analytics event with how much time it was displayed
    } else {
      const elapsedTime = Date.now() - this.time_mounted;
      analytics.sendEvent('nomination_details_viewed', {
        ceremony: this.ceremony,
        category: this.category_name,
        link_location: this.link_location,
        seconds: elapsedTime / 1000,
      });
    }

  },

  methods: {

    getFilmViewed(_film_id)
    {
      return userStore.isFilmMarkedViewed(_film_id);
    },

    hasNoOfficialNominationInThisCategory(_film) {
      return !_film.nominationsForCategory(this.category_name).some(n => !n.unofficial);
    },

    footnoteNumString(_footnotes) {
      return _footnotes.reduce((accNumbers, curFootnote) => {
        const footnoteNum = 1 + this.footnotes?.indexOf(curFootnote);
        if ( footnoteNum > 0 ) {
          return [...accNumbers, footnoteNum];
        }
        return accNumbers;
      }, []).join('\u200A,\u200A') || ''; // hair-spaces around comma make it more readable
    }
  }
}
</script>

<style scoped>

  .modal-title {
    padding-left: 10px;
  }

  a {
    text-decoration: inherit;
    color: inherit;
    cursor: pointer;
  }
  a:hover {
    color: var(--bs-link-hover-color);
  }

  .film-list {
    font-weight: 350;
    font-size: small;
  //margin-left: 10px;
  }

  .language-icon {
    padding-left: 0.2em;
    opacity: 80%;
  }

  ul {
    margin-bottom: 1rem;
    padding-left: -10px;
  }

  li {
    text-align: left;
    list-style: none;
    margin: 0;
    padding: 0 0 0 20px;

    background-repeat: no-repeat;
    background-position-x: 0px;
    background-position-y: 4px;
    background-size: 14px;
  }

  .nomination-footnote {
    /*margin-left: 0.1em;*/
    &::before {
      content: " ";
    }
    font-style: normal;
    font-size: 60%;
    color: var(--bs-secondary-color);
  }

  .nominee-text {
    font-style: italic;
    font-size: smaller;
  }

  .no-official-nominations {

    .film-name-text {
      opacity: 70%;
    }
    .nominee-text {
      opacity: 70%;
    }
  }

  /* the first non-official nomination should be separated from the rest with a faint top-border */
  :nth-child(1 of .no-official-nominations) {
    padding-top: 1.125em;
    border-style: dashed none none none;
    border-width: thin 0 0 0;
    border-color: var(--bs-border-color);
  }

  .viewed-film {

    .film-name-text {
      text-decoration: line-through!important;
      opacity: 50%;
    }

    .nominee-text {
      opacity: 50%;
    }
  }


</style>